import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { _t } from "@/lib/i18n";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const IosHelp = ({ onClose }) => (
  <div data-testid="install-ios-help" className="absolute bottom-12 left-0 w-72 tc-card p-4 border border-white/15 bg-[#0B0B0F]/95 backdrop-blur-xl shadow-2xl text-sm text-white/85">
    <button data-testid="install-ios-help-close" onClick={onClose} aria-label={_t("Chiudi")} className="absolute top-2 right-2 text-white/50 hover:text-white">
      <X className="w-4 h-4" />
    </button>
    <p className="font-medium text-white mb-2">{_t("Installa Time Capsule sul tuo iPhone")}</p>
    <ol className="space-y-1.5 list-decimal list-inside text-white/75">
      <li>{_t("Apri il sito con Safari")}</li>
      <li className="inline-flex items-center gap-1">{_t("Tocca il pulsante Condividi")} <Share className="w-3.5 h-3.5" /></li>
      <li>{_t("Scegli «Aggiungi alla schermata Home»")}</li>
    </ol>
  </div>
);

export const InstallAppButton = () => {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || (!prompt && !isIOS())) return null;

  const onClick = async () => {
    if (!prompt) { setIosHelp((v) => !v); return; }
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setPrompt(null);
  };

  return (
    <div className="relative">
      <button data-testid="install-app-button" onClick={onClick}
        className="inline-flex items-center gap-1.5 rounded-full border border-[#FF5722]/60 bg-[#FF5722]/10 px-3 py-1.5 text-xs text-white hover:bg-[#FF5722]/25 transition-colors">
        <Download className="w-3.5 h-3.5" />
        {_t("Installa l'app")}
      </button>
      {iosHelp && <IosHelp onClose={() => setIosHelp(false)} />}
    </div>
  );
};
